import React from 'react'
import {
  amtNumStr,
  amtStr,
} from '@ifca-root/react-component/src/helpers/StringNumberFunction/numFormatter'

interface DetailProps {
  listEl: any
}

export const TotalDepreciationAdjustmentDetailContent = (
  props: DetailProps
) => {
  const { listEl } = props

  return (
    <>
      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          Adjust Amount
        </div>
        <div className="mdDesc text-noflow">
          {amtStr(listEl?.adjustment_amount)}
        </div>
      </div>
      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          Net Value
        </div>
        <div className="mdDesc text-noflow">
          {amtStr(listEl?.new_book_value)}
        </div>
      </div>
      <div className="content-wrap full">
        <div className="desc" style={{ color: 'grey' }}>
          Acc. Depreciation Amount
        </div>
        <div className="mdDesc text-noflow">
          {amtStr(listEl?.new_total_depreciation)}
        </div>
      </div>
      <div className="content-wrap full">
        <div className="desc" style={{ color: 'grey' }}>
          Description
        </div>
        <div className="mdDesc text-noflow">{listEl?.description || 'N/A'}</div>
      </div>
      <div className="content-wrap full">
        <div className="desc" style={{ color: 'grey' }}>
          Reason
        </div>
        <div className="mdDesc text-noflow">{listEl?.reason || 'N/A'}</div>
      </div>
    </>
  )
}
